import { SvgIcon, SvgIconProps } from "@/domains/icons/svg-icon"

export const ChartIncreaseIcon = ({ ...rest }: SvgIconProps) => {
  return (
    <SvgIcon {...rest}>
      <path d="M21 21H3V3" stroke="currentColor"></path>
      <path d="M17.5 6L15 8M17.5 6L19.5 8M17.5 6C17.5 15.5 11 17 7 17" stroke="currentColor"></path>
    </SvgIcon>
  )
}
